module.exports = __webpack_public_path__ + "static/media/bar-code-scan.372beb1b.svg";